import { getServiceRequestCategoriesAPI } from "../../../app/api/getServiceRequestCategories";
import { BaseAction } from "../../../core/actions/BaseAction";
import { uuid } from "../../../core/utils/Uuid";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { IAdditionalField, IServiceRequestCategory, IServiceRequestCustom } from "../../../Orchestrator/Types/Interface/IServiceRequest";

class GetServiceRequestCategories extends BaseAction<void, string> {

    override async run(): Promise<void> {
        try {
            const context = this.params!
            const response: any = await getServiceRequestCategoriesAPI(context);
            if (response.status === "ok" && response.answer) {
                let categories: IServiceRequestCategory[] = response?.answer || []
                categories = categories?.filter((category) => !(category?.name === "GROUP_BOOKING" && (category?.tags || []).length == 1 && category?.tags?.[0] == "GROUP_BOOKING_FORM"))
                // Ensure unique tags                
                const uniqueTags: string[] = Array.from(new Set(categories.flatMap(item => (item?.tags || []))));
                const categoryList: IServiceRequestCustom[] = []
                uniqueTags.forEach(tag => {
                    let findSubCategory: IServiceRequestCategory[] = [...categories].filter(cat => (cat?.tags || []).includes(tag))
                    if (findSubCategory.length > 0) {
                        findSubCategory = findSubCategory.map((cat: IServiceRequestCategory) => {

                            let modifiedAdditionalFields: IAdditionalField | any = cat?.additionalFields || []
                            if ((cat?.additionalFields || []).length > 0) {
                                modifiedAdditionalFields = (cat?.additionalFields || []).map((field) => ({
                                    ...field,
                                    fieldId: uuid()
                                }))
                            }

                            /**
                            * Added comment field from FE side based on contentIsRequired
                            */
                            if ("contentIsRequired" in cat) {
                                modifiedAdditionalFields.push({
                                    fieldId: uuid(),
                                    title: "COMMENT",
                                    type: "TEXT",
                                    maxLines: 4,
                                    required: cat.contentIsRequired
                                })
                            }

                            /**
                             * In a category if we have PASSENGER_NAME
                             * then we need to show two fields
                             * FirstName and LastName in 50% width.
                            */
                            const isMultiPassenger =
                                modifiedAdditionalFields.filter(
                                    (d: IAdditionalField) =>
                                        d.type === "PASSENGER_NAME" &&
                                        ["CURRENT_NAME", "NEW_NAME"].includes(d.title)
                                ).length >= 2;
                            if (!isMultiPassenger) {
                                const index = modifiedAdditionalFields.findIndex((item: IAdditionalField) => item.type === "PASSENGER_NAME" && ["FIRSTNAME_LASTNAME", "NAME"].includes(item.title));
                                if (index !== -1) {
                                    modifiedAdditionalFields.splice(index, 1, {
                                        ...modifiedAdditionalFields[index] || {},
                                        fieldId: uuid(),
                                        title: "PASSENGER_FIRST_NAME",
                                        type: "TEXT",
                                        width: "50%",
                                    }, {
                                        ...modifiedAdditionalFields[index] || {},
                                        fieldId: uuid(),
                                        title: "PASSENGER_LAST_NAME",
                                        type: "TEXT",
                                        width: "50%",
                                    });
                                }
                            } else {
                                const index = modifiedAdditionalFields.findIndex(
                                    (d: IAdditionalField) =>
                                        d.type === "PASSENGER_NAME" &&
                                        ["CURRENT_NAME", "NEW_NAME"].includes(d.title))
                                if (index !== -1) {
                                    modifiedAdditionalFields.splice(index, 1, {
                                        ...modifiedAdditionalFields[index] || {},
                                        fieldId: uuid(),
                                        type: "PASSENGER_NAME_CHANGE",
                                    })
                                    modifiedAdditionalFields = modifiedAdditionalFields.filter((d: any) => d.type !== "PASSENGER_NAME" && (d.title !== "CURRENT_NAME" || d.title !== "NEW_NAME"))
                                }
                            }
                            return {
                                ...cat,
                                additionalFields: modifiedAdditionalFields
                            };
                        })
                    }
                    const categoryData = {
                        categoryName: tag,
                        subCategories: findSubCategory
                    }
                    categoryList.push(categoryData)
                })
                updateRecoilState("serviceCategoriesAtom", categoryList)
            }
        } catch (error: any) {
            console.error("Error fetching Data:", error);
        }
    }
}

export const getServiceRequestCategories = new GetServiceRequestCategories()